import React, { useState, useMemo, useEffect } from 'react';
import { Row, Col } from 'tea-component'

import CardHead from '@/pages/dashboard/components/CardHead'

import RankTop from '../RankTop';
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import { useLocal, useSelectorMap } from '@/pages/dashboard/utils/customHook';
import { formatFilterValues, formatNum, formatPercentNum, getIsErrorValue, getRatioText, IsSingleDay } from '@/pages/dashboard/utils/utils';
import { getCountryFlag } from '@/pages/home/_config/countries';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getBreakDownHeader } from '../../../engagement/_config/utils';
import { getDefaultDateValue } from '@/pages/dashboard/_config/defualtTime';
import { PUBG_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';

import '../uaRankMetric.scss';
import './index.scss';

interface Props {
  gameCode: string
  filterLoading: boolean
  formValue: any
}

const headerText: any = {
  'Country':'common_Country',
  'Region':'common_Region',
  'Network type':'common_netWork_Type',
  'Zone':'common_Zone',
  'Register':'ua_chart_register',
  'CPA($)':'ua_table_cpa',
  'LTV7':'ua_LTV7',
  'Sum Register':'ua_Sum_Register',
  'Share of ALL':'ua_Share_of_ALL',
  'Avg. LTV7':'ua_Avg_LTV7',
  'Avg. CPA($)':'ua_Avg_CPA',
  'Sum Return':'return_Sum_Retrun',
  'Return':'return_return',
  'New': 'engagement_register_New',
  'Sum New': 'engagement_register_Sum_New',
  'Network_type':'common_netWork_Type',
  
}

const titleTrans: any = {
  'Register of Top 10 Countries': 'ua_Top_Country',
  'Register of Top 10 Regions': 'ua_Top_Region',
  'Register of Network Type ': 'ua_Top_Network',

  'CPA of Top 10 Countries': 'ua_CPA_Top_Countries',
  'CPA of Top 10 Regions': 'ua_CPA_Top_Region',
  'CPA of Network Type ': 'ua_CPA_Top_Network',

  'LTV7 of Top 10 Countries': 'ua_Ltv7_Top_Country',
  'LTV7 of Top 10 Regions': 'ua_Ltv7_Top_Region',
  'LTV7 of Network Type ': 'ua_Ltv7_Top_Network',

}

const TAB_NAME: any = {
  Day: 'daily',
  Week: 'weekly',
  Month: 'monthly'
}

const SpendRankTop = (props: Props) => {
  const { formValue, filterLoading, gameCode } = props;
  const { filterValue, timeType, diff} = formValue
  const { rangeTime, ...filters } = filterValue || {};
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode)
  const defaultTimeRange = getDefaultDateValue(filterValue?.timeType,false,isPUBGM);
  const {getUaSelectorText} = useSelectorMap();
  const timeRangeArr = diff ? defaultTimeRange : rangeTime;

  const {getLocalText } = useLocal();
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [data, setData] = useState<any>({})
  const [regionType, setRegionType] = useState<any>('country')

  const typeMap: any = {
    country: 'country',
    region: 'region',
    network_type: 'network'
  }

  const isSingle = useMemo(() => {
    return IsSingleDay({
      start_time: timeRangeArr?.[0],
      end_time: timeRangeArr?.[1],
      period: timeType
    },true)
  }, [formValue])

  const COUNTRY_REGION_TYPE = [
    { text: getLocalText('ua_tab_country'), value: 'country' },
    { text: getLocalText('ua_tab_Region'), value: 'region' },
    { text: getLocalText('ua_tab_Network'), value: 'network_type' }
  ];

  const getColumns = (key: string) => {
    const prefixMap: any = {
      CPA: 'Avg.',
      LTV7: 'Avg.',
      Register: 'Sum'
    }
    const prefix = prefixMap[key]
    const headerMap: any = {
      'Register': getBreakDownHeader(regionType, isSingle, 'Register', prefix ?? '')[regionType],
      'CPA': getBreakDownHeader(regionType, isSingle, 'CPA', prefix ?? '')[regionType],
      'LTV7': getBreakDownHeader(regionType, isSingle, 'LTV7', prefix ?? '')[regionType],
    }
    const unitMap: any = {
      CPA: '($)'
    }

    const { countryName, valueName, share } = headerMap[key]
    const unit = unitMap[key] ?? ''

    const countryHead = headerText[countryName] ? getLocalText(headerText[countryName]) : countryName
    const valueHead = headerText[valueName + unit] ? getLocalText(headerText[valueName + unit]) : valueName + unit
    const shareHead = headerText[share] ? getLocalText(headerText[share]) : share

    const columns: any = [
      {
        key: 'full_name',
        header: countryHead,
        width: 250,
        align: 'left',
        render: (t: any) => {
          let ImgDom: JSX.Element;
          try {
            ImgDom =  (t?.full_name?.toLowerCase()?.trim() === 'others' || t?.name?.toLowerCase()?.trim() === 'others')? <></> :
              <img className='country-icon' src={getCountryFlag(t?.name)} alt="flag" />;
          } catch (error) {
            ImgDom = <img className='country-icon' src={getCountryFlag('undefined')} alt="flag" />;
          }

          return (
            <div className='overview-country dbd-ua-rank-td-div'>
              {regionType === 'country' && ImgDom}
              <span className='dbd-ua-rank-span'>{(t?.full_name || t.full_name !== null) ? getUaSelectorText(typeMap[regionType], t.full_name) : '-'}</span>
            </div>
          );
        },
      },
      {
        key: 'value',
        header: valueHead,
        align: key === 'Register' ? 'right' : 'center',
        // render: (record: any) => {
        //   const { text, status } = getRatioText(record.change)
        //   const isUp = status === 'up'
        //   const num = formatNum(record.value, false, key === 'Register')
        //   const isEmpty = num === '-' && status === 'no'

        //   return (
        //     <div className={`table-desc dbd-ua-table-desc-${key === 'Register' ? 'right' : 'center'}`}>
        //       {
        //         isEmpty ? <div className='register-table-daily-grey'>-</div> : (
        //           <>
        //             <div className='table-desc-textsum'>{num}</div>
        //             {
        //               status === 'no' ? (
        //                 <div className='dbd-ua-table-desc-ratio-empty'>-</div>
        //               ) : (
        //                 <>
        //                   <div className={isUp ? 'table-desc-red' : 'table-desc-green'}>{text}</div>
        //                   <SvgIcon type={isUp ? 'top-red' : 'bottom-green'} className='table-desc-icon' />
        //                 </>
        //               )
        //             }
        //           </>
        //         )
        //       }
        //     </div>
        //   )
        // }
        render: (t: any) => {
          const { text, status } = getRatioText(t?.change, false);
          const value = formatNum(t?.value, false, key === 'Register');
          const isAllNUll = ((status === 'zero' || status === '') && value === '-');
          const ratioStatusClass = status === 'down'
            ? 'dbd-ua-rank-metric__ratio--red'
            : status === 'zero' || status === ''
              ? 'dbd-ua-rank-metric__ratio--grey'
              : 'dbd-ua-rank-metric__ratio--green';
          return (
            <div className={`dbd-ua-rank-metric${key === 'Register' ? '' : ' dbd-ua-rank-metric--center'}`}>
              {
                isAllNUll ? <div className="dbd-ua-rank-metric__ratio dbd-ua-rank-metric__ratio--grey">-</div> :
                  <>
                    <div className="dbd-ua-rank-metric__value">{value}</div>
                    <div className={`dbd-ua-rank-metric__ratio ${ratioStatusClass}`}>{text}
                      {
                        status === '' ? '' : status === 'zero' ? <div className="dbd-ua-rank-metric__line" /> : <SvgIcon type={status === 'down' ? 'red-down-new' : 'green-up-new'} className="dbd-ua-rank-metric__icon" />
                      }
                    </div>
                  </>
              }
            </div>
          );
        },
      }
    ]

    if (key === 'Register') {
      columns.push({
        key: 'share_of_all',
        align: 'center',
        width: 140,
        header: shareHead,
        render: (t: any) => {
          let share_of_all: any = '-';
          if (getIsErrorValue(t?.share_of_all)) {
              share_of_all = '-';
          } else {
              share_of_all = formatPercentNum(parseFloat(t.share_of_all.trim()), 1);
          }
          return (<span>{share_of_all}</span>);
        }
      })
    }

    return columns
  }

  const getTitle = (key: string) => {
    const titleObj: any = {
      country: `${key} of Top 10 Countries`,
      region: `${key} of Top 10 Regions`,
      network_type: `${key} of Network Type `,
    }
    return titleTrans[titleObj[regionType]] ? getLocalText(titleTrans[titleObj[regionType]]) : titleObj[regionType]
  }

  const update = () => {
    const params = {
      period: TAB_NAME[timeType],
      game_code: gameCode,
      start_time: timeRangeArr[0],
      end_time: timeRangeArr[1],
      filters: formatFilterValues(filters),
      by_type: regionType
    }
    setLoading(true)
    setError(false);
    dashboardRequest({
      url: `/api/v1/dashboard/ua/no_spend/register_distribution`,
      method: 'post',
      data: params,
    })
      .then((data: any) => {
        setData({
          Register: {
            chartData: data?.register_date_list || [],
            tableData: data?.register_list || []
          },
          CPA: {
            chartData: data?.cpa_date_list || [],
            tableData: data?.cpa_list || []
          },
          LTV7: {
            chartData: data?.ltv7_date_list || [],
            tableData: data?.ltv7_list || []
          }
        })
        setError(false)
      })
      .catch((err) => {
        console.log(err)
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (filterLoading) return
    update()
  }, [
    // gameCode,
    regionType,
    filterLoading,
    formValue
  ])
  
  return (
    <>
      <Row>
        <Col span={24}>
          <CardHead
            title={getLocalText('ua_Country_Region_Network_TypeBreakdown')}
            value={regionType}
            data={COUNTRY_REGION_TYPE}
            onChange={setRegionType}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <RankTop
            tableColumn={getColumns('Register')}
            title={getTitle('Register')}
            titleAndType="Register"
            isUserQuota={true}
            timeType={timeType}
            tableData={data?.Register?.tableData}
            chartData={data?.Register?.chartData}
            isUserMetrics={true}
            gameCode={gameCode}
            regionType={typeMap[regionType]}
            filterValue={filterValue}
            loading={loading}
            error={error}
            hasShare={true}
          />
        </Col>
        <Col span={24}>
          <RankTop
            tableColumn={getColumns('LTV7')}
            title={getTitle('LTV7')}
            titleAndType="LTV7"
            timeType={timeType}
            tableData={data?.LTV7?.tableData}
            chartData={data?.LTV7?.chartData}
            gameCode={gameCode}
            filterValue={filterValue}
            regionType={typeMap[regionType]}
            loading={loading}
            error={error}
            isAllUpper={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default SpendRankTop;
